import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import DailyStockMovementReportActions from '../../Stores/DailyStockMovementReport/Actions';

const { Panel } = Collapse;

class DailyStockMovementReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initDailyStockMovement } = this.props;

    if (curSiteFlowId > 0) {
      initDailyStockMovement();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initDailyStockMovement } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initDailyStockMovement();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'daily_stock_movement_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

DailyStockMovementReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initDailyStockMovement: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

DailyStockMovementReportScreen.defaultProps = {
  intl: {},
  match: {},

  initDailyStockMovement: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initDailyStockMovement: () =>
    dispatch(DailyStockMovementReportActions.dailyStockMovementReportInitDailyStockMovement())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(DailyStockMovementReportScreen));
